// extracted by mini-css-extract-plugin
module.exports = {"input":"_93444fe79c--input--o7QjY","postfix":"_93444fe79c--postfix--FNMkj"};